import * as React from 'react';
import { Button } from 'reactstrap';
import LoadingIndicator from './LoadingIndicator';

export type Props = {
  children: React.ReactNode;
  sending: boolean;
  attaching: boolean;
  disabled?: boolean;
  onClick: (arg0: any) => any;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export default class SendTicketButton extends React.PureComponent<Props> {
  render() {
    const { children, sending, attaching, disabled, onClick, ...rest } =
      this.props;
    let buttonLabel = children;
    if (sending) {
      buttonLabel = <LoadingIndicator light>Sending...</LoadingIndicator>;
    } else if (attaching) {
      buttonLabel = <LoadingIndicator light>Attaching...</LoadingIndicator>;
    }

    return (
      <Button
        color="primary"
        {...rest}
        disabled={disabled || sending || attaching}
        onClick={onClick}
      >
        {buttonLabel}
      </Button>
    );
  }
}
